import type { ExtensionSchema } from '@/vantage/types/Extension.types';
import { VantageNames } from '@/vantage/constants';
import _ from 'lodash';

const upgradeReviewedStaleIcon = (config: ExtensionSchema): ExtensionSchema => {
  if (
    config.name === VantageNames.Extensions.Reviewed &&
    config.uiConfig?.columns?.[0]?.discreteStates?.[1]?.iconFill
  ) {
    const newConfig = structuredClone(config);
    delete newConfig.uiConfig!.columns![0]!.discreteStates![1]!.iconFill;
    delete newConfig.uiConfig!.columns![0]!.discreteStates![2]!.iconFill;
    newConfig.uiConfig!.columns![0]!.discreteStates![2]!.icon = 'svgpath:M 0 0 L 0 20 L 20 20 L 20 0 Z';
    return newConfig;
  }
  return config;
};

const upgradeReasonCodesArchiveChildren = (config: ExtensionSchema): ExtensionSchema => {
  if (
    config.name === VantageNames.Extensions.ReasonCodes &&
    config.contextCharacteristics?.length &&
    _.isNil(config.contextCharacteristics[0].archiveChildren)
  ) {
    const newConfig = structuredClone(config);
    newConfig.contextCharacteristics![0].archiveChildren = true;
    return newConfig;
  }
  return config;
};

const upgrades = [upgradeReviewedStaleIcon, upgradeReasonCodesArchiveChildren];

export const upgradeExtensions = (extensionConfig: ExtensionSchema) => {
  return upgrades.reduce((config, upgrade) => upgrade(config), extensionConfig);
};
